// store/modules/inquiries/actions.js
import InquiriesApi from "../../../api/modules/InquiriesApi";

const searchInquiries = (_, payload) => {
  const {context, ...data} = payload;
  return InquiriesApi.searchInquiries(context, data);
};

const getInquiryById = (_, payload) => {
  return InquiriesApi.getInquiryById(payload.context, payload.id);
};

const changeStatusInquiry = (_, payload) => {
  return InquiriesApi.changeStatusInquiry(payload.context, payload.idInquiry, payload.request);
};

const exportInquiriesExcel = (_, payload) => {
  return InquiriesApi.exportInquiriesExcel(payload.context, payload.filters);
};

const exportInquiriesPdf = (_, payload) => {
  return InquiriesApi.exportInquiriesPdf(payload.context, payload.filters);
};

const exportInquiriesDetailExcel = (_, payload) => {
  return InquiriesApi.exportInquiriesDetailExcel(payload.context, payload.filters);
};

const exportInquiriesDetailPdf = (_, payload) => {
  return InquiriesApi.exportInquiriesDetailPdf(payload.context, payload.filters);
};

const loadReportInquiries = (_, payload) => {
  return InquiriesApi.loadReportInquiries(payload.context, payload);
};

const loadReportInquiriesExcel = (_, payload) => {
  return InquiriesApi.loadReportInquiriesExcel(payload.context, payload);
};

export default {
  searchInquiries,
  getInquiryById,
  changeStatusInquiry,
  exportInquiriesExcel,
  exportInquiriesPdf,
  exportInquiriesDetailExcel,
  exportInquiriesDetailPdf,
  loadReportInquiries,
  loadReportInquiriesExcel
};



// WEBPACK FOOTER //
// ./src/store/modules/inquiries/actions.js